// extracted by mini-css-extract-plugin
export default {"host":"MediaToolbar_host__xaEQF"};